export default __webpack_public_path__ + "static/media/screen1.24da8ea7.png";